<template>
    <div class="main-container p-3 col-12 col-md-10 border mb-4">
        <div>
            <span class="add-on">{{ this.translatedText }}</span
            ><br />
            <span>{{ 'Get more Credits for premium tasks.' | trans }}</span>
        </div>
        <div class="price">
            <span v-if="!this.unitPrice" class="w-100 d-flex pl-4">
                <span class="spin-circle-basic spin-circle-225 spin-circle-medium"></span>
            </span>
            <span v-if="this.unitPrice"
                ><span class="font-weight-bold add-on">{{ this.unitPrice }}</span> {{ this.translatedUnit }}</span
            >
        </div>
        <div>
            <span class="btn btn-lg btn-app-color" @click="this.openPaymentModal"
                >{{ 'Buy Credits' | trans }} <i class="fa fa-chevron-right" />
            </span>
        </div>
    </div>
</template>
<script>
import { registerPaymentModalHelper } from '../../../../lib-sat/user/modal/register_payment_flow/register-payment-modal-helper';
import { paymentManager } from '../../../../lib-sat/payment/payment-manager';
import { pageStoreMixin } from '../../../../lib-sat/store/page-store';
import { userManager } from '../../../../lib-sat/user/user-manager';
import TransFilter from './mixins/TransFilter.vue';
import { translate } from '../../../helper/translate';
import { paymentApi } from '../../../../lib-sat/payment/payment-api';
import { satGlobals } from '../../../sat/helper/sat-globals';
export default {
    name: 'BuyCreditsBox',
    mixins: [TransFilter, pageStoreMixin],
    data() {
        return {
            unitPrice: '',
            creditUnit: '',
        };
    },

    async mounted() {
        await this.handleCreditUnit();
        await this.getPaymentInfo();
    },
    computed: {
        translatedUnit() {
            return translate('for %unit% Credits', { '%unit%': '500' });
        },
        translatedText() {
            if (satGlobals.isCreditsInAllSatsEnabled()) {
                return translate('Pay As You Go');
            } else {
                return translate('Add On');
            }
        },
    },
    methods: {
        async openPaymentModal() {
            const getUser = await userManager.getUser();

            if (getUser.isPremium()) {
                registerPaymentModalHelper.openForPricingPremium();
            } else {
                registerPaymentModalHelper.openUpgrade();
            }
        },

        async handleCreditUnit() {
            const getUser = await userManager.getUser();
            let currency = getUser.isFromEurope() ? 'eur' : 'usd';
            this.creditUnit = `credits_500_${currency}`;

            return Promise.resolve();
        },

        async getPaymentInfo() {
            if (!paymentManager.isPricingInfoInitialized()) {
                const pricingInformation = await paymentApi.getPricingInformation(true);

                paymentManager.setConfigFromPricingInformation(pricingInformation);
            }
            this.unitPrice = await paymentManager.getSlugHelper().getPriceStringFromSlug(this.creditUnit);
        },
    },
};
</script>
<style scoped>
.main-container {
    background-color: white;
    height: 276px;
    border-radius: 10px;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
}
.main-container:hover {
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.075);
}
.add-on {
    font-size: 32px;
}
.btn-app-color {
    background-color: #4285f4;
    color: white;
}
.btn-app-color:hover {
    background-color: #1e6ef2;
}
.price {
    font-size: 16px;
}
</style>
